module.exports = __webpack_public_path__ + "img/logo-leanbot-large.bad67f02.png";